/* import store from '@/scripts/store'; */
import { checkCloseModalMenu } from '@/scripts/methods';

const publicRoutes = [
  '',
  'login',
  'sign-up',
  'reset',
  'registration',
  'oauth',
  'coming-soon',
  'terms',
  'unsubscribe',
  /*  */
  'leaderboard',
];

const beforeEach = (to, from, next) => {
  const { name = '', path = '' /* matched = [] */ } = to;
  /* > props */
  /* const [setup = {}] = matched;
  const { props = {} } = setup;
  const { default: routeProps } = props; */
  /* < props */
  /* const { user } = store.state; */

  /* path */
  const [, route, subroute] = path.split('/');
  const token = localStorage.getItem('token');
  const publicRoute =
    publicRoutes.includes(route) || publicRoutes.includes(subroute);

  if (!token) {
    /* unauth */
    if (publicRoute) {
      next();
    } else {
      next('/login');
    }
  } else {
    /* auth */
    switch (name) {
      case 'Login':
        next('/dashboard');
        break;

      default:
        next();
        break;
    }
  }

  /* mobile (modal) menu turn off */
  checkCloseModalMenu();
};

const afterEach = () => {
  /* to, from */
  // console.log('');
};

const scrollBehavior = (to, from, savedPosition) => {
  return savedPosition ? savedPosition : { x: 0, y: 0 };
};

/*  */
export { publicRoutes, beforeEach, afterEach, scrollBehavior };
